@if(canDisplay()) {
  <div class="banner-message">
    <img src="./assets/icons/c2u-warning.svg" alt="">
    <p>{{message()}}</p>
    <ion-icon (click)="close()" name="close-outline"></ion-icon>
  </div>
}